<template>
    <div>
      <v-container>
    
       <v-row>
   
         <v-col cols="12">
                    <div class="text-center ma-4">
                             <img :src="company.logo" v-if="!IsEmpty(company.logo)" height="90px"/>
                             <img v-else :src="$store.state.systemlogo" height="90px"/> 
                    </div>
                    <v-btn text tile   @click="$router.push('/tracker').catch(err => {})">
                        <v-icon left large>mdi-arrow-left</v-icon> Back
                    </v-btn> 
                    <template v-if="sales.id != null">
                   <v-card elevation="1" >
                  <v-toolbar elevation="0">
                    <v-icon left color="primary">mdi-text-box-multiple-outline</v-icon> {{sales.type}}  <v-divider vertical inset class="ml-5 mr-2"/>
                    <span :class="TEXT_COLOR(sales.status)">{{sales.status}}</span>
                 
             
                  
                  </v-toolbar>
                  <v-card-text>
                     <table class="va-table va-table-border-bot">
                        <thead>
                          <tr>
                            <th width="100px" class="pa-2">NUMBER:</th>
                            <th class="pa-2">{{sales.id}}</th>
                             <th  width="100px" class="pa-2">DATE:</th>
                            <th class="pa-2">{{$moment(sales.created_at).format("MMM DD, YYYY")}}</th>
                           </tr> 
                           
                        </thead>
                        <tbody>
                           <tr>
                            <td class="pa-2">CUSTOMER:</td>
                             <td colspan="3" class="pa-2">{{sales.customer_data.fullname}}</td>
                          </tr>
                        </tbody>
                     </table>
                    
                     <table class="va-table va-table-border-bot">
                  <tr>
              
                    <th>Item</th>
                    <th>Discription</th>
                    <th class="text-center" width="120">QTY</th>
                    <th class="text-right">Price</th>
                    <th class="text-right">Amount</th>
                  </tr>
                  <tr  v-for="(item, index) in sales.product_items" :key="index+'-v'">
                   
                    <td><span class="font-weight-bold">{{ item.name }}</span>
                        <br/><span class="font-italic def-font text-info" v-if="item.code!='null'">code: {{ item.code }}</span>
                    </td>
                     <td>
                      <p class="ma-1">{{ item.description }}</p>
                        <p class="ma-1 def-font" v-for="(_prop, _index) in item.properties" :key="_index+'-p'">{{_prop.name}} : {{_prop.value}} </p>
                    </td>
                    <td class="text-center">
                        {{item.quantity}}             
                    </td>
                    <td class="text-right">{{ $money(item.selling_price )}}</td>
                    <td class="text-right">{{ $money(item.amount * item.quantity )}}</td>
                  </tr>


                  <tr class="font-weight-bold">
                    <td class="text-right" colspan="4">SUB-TOTAL:</td>
                    <td class="text-right">{{$money(sales.sales_amount)}}</td>
                  </tr> 
                  <tr class="font-weight-bold" v-if="sales.tax != ''">
                    <td class="text-right" colspan="4">TAX:</td>
                    <td class="text-right">{{$money(sales.tax)}}</td>
                  </tr>
                   <tr class="font-weight-bold text-warning" v-if="sales.discount != ''">
                    <td class="text-right" colspan="4">DISCOUNTS:</td>
                    <td class="text-right">{{$money(sales.discount)}}</td>
                  </tr>
                  <tr class="font-weight-bold text-h6">
                    <td class="text-right" colspan="4">TOTAL:</td>
                    <td class="text-right">{{$money(sales.total_amount)}}</td>
                  </tr>
                </table>
                  </v-card-text>             
                </v-card>
                <v-card color="light_gray" class="mt-4">
                 <v-card-text class="pa-4 def-font">
                      <v-icon left small color="warning">mdi-folder-multiple-image</v-icon>Images
                        <v-divider class="mb-4"/>
                        <div>
                          <v-divider class="mb-2"/>
            <span v-if="sales.files !='' ">
                   <img 
                   width="150"
                   class="ma-1 imgview"
                   @click="imgsrc = img, imgview=true"
                  v-for="(img,m) in sales.files"
                  :key="m +'-fm'"
                   :src="img">
            </span>
                        </div>
                  </v-card-text>
              </v-card>
                   
    <v-card color="light_gray" class="mt-4">
          <v-card-text class="pa-4 def-font">
             <v-icon left small color="warning">mdi-cogs</v-icon> Activities and Updates
              <v-divider class="mb-4"/>
                <v-list two-line>
                <v-list-item  v-for="(item, index) in logs" :key="index + '-l'" style="border-bottom: 1px solid #ddd; padding:0" >
                <v-list-item-content>
                    <v-list-item-subtitle><span class="text--primary">{{ item.user }} - </span> {{ item.message }}</v-list-item-subtitle>
                     <v-list-item-subtitle><span class="text-info font-italic def-font">{{ item.timestamp }} </span></v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
              
              </v-list>  
                
          </v-card-text>
    </v-card>
    </template>
      <template v-else>
            <div class="text-center text-h6 text-error mt-8"><p>We cant find you service number!</p></div>   
      </template>
             </v-col>
           
       </v-row>
       </v-container>
       <zera-image-viewer :show="imgview" :imgsrc="imgsrc" @DialogEvent="imgview = false"/>
     </div>
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'

     export default {
       data: () => ({
          salesID:0,
          sales:{customer_data:{fullname:""}},
          imgview: false,
          imgsrc:'',
          logs:[],
           company:{name:"",logo:"",address:"",tel:"", mobile:"", email:""}
       }),
       beforeCreate: function () {
       
       },
       created() {
        this.setLoggedIn(false) 
        console.log(this.$route.params.id);
        this.salesID = this.$IsNum(this.$route.params.id)
        this.getJob()
         this.SETVARS()
        setTimeout(()=>{
           this.company = {
            name:this.GET_SYSVARS('company_name'),
            logo:this.GET_SYSVARS('company_logo'),
            address:this.GET_SYSVARS('company_address'),
            tel:this.GET_SYSVARS('company_tel'), 
            mobile:this.GET_SYSVARS('company_email'),
            email:this.GET_SYSVARS('company_mobile'),
          }
        },200)
       },
       computed:{
        
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
       
         getJob() { 
           this.$http.post("view_sales", {id: this.salesID}).then(response => {
          console.log(response)
        
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        
          this.sales = response.data.sale
          this.logs = this.sales.service_logs
   
        }).catch(e => {
          console.log(e.data)
        })
        }
       }
     }
   </script>